import React, { useState } from "react";
import { updateData } from "../../utility/adminApiv3";
import CancelIcon from "@mui/icons-material/Cancel";

function EditBill({
  singleData,
  setSingleData,
  fetchBills,
  setEdittab,
  currentPage,
}) {
  const [, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target; // Destructure name and value from event target
    setSingleData((prevData) => ({
      ...prevData,
      [name]: value, // Update the corresponding field in state
    }));
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();

    // Log singleData before submission to check its content

    const keysToExtract = ["name", "percentage", "description"];
    const newSingleData = Object.keys(singleData)?.reduce((result, key) => {
      if (keysToExtract.includes(key)) {
        result[key] = singleData[key];
      }
      return result;
    }, {});

    const response = await updateData(
      "/auto-bills/update/",
      singleData.id,
      newSingleData
    );

    let errorCheck = response?.response?.data?.error;

    if (errorCheck) {
      setLoading(false);
    } else {
      fetchBills(currentPage);
      setEdittab(false);
      setLoading(false);
    }
  };

  return (
    <div className="bg-white p-6 rounded-md">
      <div className="flex justify-end">
        <CancelIcon
          className="cursor-pointer"
          onClick={() => setEdittab(false)}
        />
      </div>

      <h2 className="text-2xl font-medium text-center">Edit Bill </h2>
      <form
        onSubmit={handleEditSubmit}
        className="py-12  flex flex-col justify-center items-center gap-6 "
      >
        <div className="flex  flex-col lg:w-[400px]">
          <label htmlFor="">Name</label>
          <input
            className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
            placeholder="Email"
            type="text "
            name="name"
            // id="email"
            value={singleData?.name}
            onChange={handleChange}
            required
          />
        </div>
        <div className="flex 1/2 flex-col">
          <label htmlFor="">Percentage</label>
          <input
            className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
            placeholder="Email"
            type="text "
            name="percentage"
            // id="email"
            value={singleData?.percentage}
            onChange={handleChange}
            required
          />
        </div>
        <div className="flex flex-col">
          <label htmlFor="">Description</label>
          <input
            className="border-2 border-gray-300 p-2 rounded-md w-full  focus:border-teal-500 focus:outline-none lg:w-[400px]"
            placeholder="First Name"
            type="text "
            name="firstname"
            // id="email"
            value={singleData?.description}
            onChange={handleChange}
            required
          />
        </div>

        <button
          // disabled={loading}
          type="submit"
          className="px-4 py-3 text-white rounded-lg w-full lg:w-[400px] bg-blue-500"
        >
          {/* {loading ? "Saving..." : "Save Product"} */}
          Update
        </button>
      </form>
    </div>
  );
}

export default EditBill;
